module.exports = __webpack_public_path__ + "img/bill.7471ccee.png";